import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { SeoCoursePageFaqRoutingModule } from './seo-cource-page-faq-routing.module';
import { SeoCoursePageFaqListComponent } from './seo-course-page-faq-list/seo-course-page-faq-list.component';
import { SeoCoursePageFaqCreateComponent } from './seo-course-page-faq-create/seo-course-page-faq-create.component';

@NgModule({
  declarations: [SeoCoursePageFaqListComponent, SeoCoursePageFaqCreateComponent],
  imports: [
    CommonModule,
    SeoCoursePageFaqRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class SeoCoursePageFaqModule { }
